import templateUrl from './emailNotifyBlock.tpl.html';
import isEmail from 'validator/lib/isEmail';

angular.module('signalview.detector.notification').directive('emailNotifyBlock', [
    '$timeout',
    'featureEnabled',
    function ($timeout, featureEnabled) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                model: '=ngModel',
                remove: '&onRemove',
                readOnly: '=?',
                doneEdit: '&onFinishEdit',
                disableCcBcc: '<?',
            },
            templateUrl,
            link: function ($scope, element) {
                $scope.emailCcBccEnabled =
                    featureEnabled('emailNotificationCcBcc') && !$scope.disableCcBcc;

                // Initialize before any editMode() call so the error state is always safe to access.
                $scope.toEditState = { error: '' };

                $scope.finishEdit = function () {
                    if ($scope.model.email) {
                        if ($scope.emailCcBccEnabled && !isEmail($scope.model.email)) {
                            $scope.toEditState.error = 'Invalid email address';
                            return;
                        }
                        $scope.edit = false;
                    } else {
                        if ($scope.remove) $scope.remove();
                    }
                    if ($scope.doneEdit) $scope.doneEdit();
                };

                $scope.editMode = function () {
                    $scope.edit = true;
                    $scope.toEditState.error = '';
                    $timeout(function () {
                        element.find('input')[0].focus();
                    });
                };

                if (!$scope.model.email) {
                    $scope.editMode();
                }

                if ($scope.emailCcBccEnabled) {
                    element.addClass('email-cc-bcc-active');

                    $scope.removeCc = function (index) {
                        if ($scope.model.cc) {
                            $scope.model.cc.splice(index, 1);
                        }
                    };

                    $scope.removeBcc = function (index) {
                        if ($scope.model.bcc) {
                            $scope.model.bcc.splice(index, 1);
                        }
                    };

                    // Object (dot notation) so ng-model inside ng-repeat child scopes
                    // correctly mutates this parent-scope property.
                    $scope.ccBccEdit = { type: null, index: -1, email: '', error: '' };

                    $scope.editCcBcc = function (type, index) {
                        const arr = type === 'cc' ? $scope.model.cc : $scope.model.bcc;
                        $scope.ccBccEdit = {
                            type,
                            index,
                            email: arr ? arr[index] || '' : '',
                            error: '',
                        };
                        $timeout(function () {
                            const input = element.find('.cc-bcc-edit-input')[0];
                            if (input) input.focus();
                        });
                    };

                    $scope.finishCcBccEdit = function () {
                        const email = ($scope.ccBccEdit.email || '').trim();
                        const { type, index } = $scope.ccBccEdit;
                        if (email && !isEmail(email)) {
                            $scope.ccBccEdit.error = 'Invalid email address';
                            return;
                        }
                        // Reset edit state before DOM mutations to avoid flicker.
                        $scope.ccBccEdit = { type: null, index: -1, email: '', error: '' };
                        if (email) {
                            const arr = type === 'cc' ? $scope.model.cc : $scope.model.bcc;
                            if (arr && index >= 0 && index < arr.length) {
                                arr[index] = email;
                            }
                        } else {
                            if (type === 'cc') {
                                $scope.removeCc(index);
                            } else if (type === 'bcc') {
                                $scope.removeBcc(index);
                            }
                        }
                    };
                }
            },
        };
    },
]);
